import React, { useMemo } from "react";

import { isRequirementPolicy } from "@design-controls/types";
import { QFormControl, QMultiSelect } from "@qualio/ui-components";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useCurrentConfigs } from "../../../hooks/useCurrentConfigs";

export const RequirementType: React.FC = () => {
  const { t } = useTranslation();
  const configs = useCurrentConfigs();

  const options = useMemo(() => {
    return configs
      .filter(isRequirementPolicy)
      .map((config) => ({ label: config.label, value: config.type }));
  }, [configs]);

  return (
    <Controller
      name="type"
      render={({ field: { onChange, value } }) => (
        <QFormControl label={t("filters.requirementType")}>
          <QMultiSelect
            value={value}
            onChange={(selectedItem) =>
              onChange(selectedItem.map((item) => item.value))
            }
            options={options}
          />
        </QFormControl>
      )}
    />
  );
};
